import { Icon, InputField } from "components";
import Button from "components/atoms/Button/Button";
import { Empty } from "components/atoms/Empty";
import { InputRange } from "components/atoms/InputRange";
import InputSelect from "components/atoms/InputSelect/InputSelect";
import {
  OPTIONS_FILTER_SCORING,
  OPTIONS_LEADSCORE_FILTER,
  OPTIONS_LOCATION_COUNTRY,
} from "components/modules/SearchMain/SearchMainHelper";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

interface RowsProps {
  id: string;
  name: string;
  value: any;
  weight: number;
}
interface Options {
  label: string;
  value: string | number;
}
export const FormLeadScoring = () => {
  const form = useFormContext<{
    activeStep: Number;
    state: Options[];
    businessType: "B2C" | "B2B";
    rows: RowsProps[];
  }>();
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "rows",
  });
  const businessType = form.watch("businessType");
  return (
    <>
      {businessType === "B2B" ? (
        <>
          {fields.length ? (
            <>
              <section className="col-span-12 !flex !flex-col md:grid-rows-1 md:grid md:grid-cols-12 w-full gap-4 mt-4">
                <header className="col-span-12 grid grid-cols-12 border-t border-b  !text-gray-200 border-gray-700 items-center gap-2 color-gray-200 space-x-4 !max-h-[120px]">
                  <div className="flex col-span-3 justify-center items-center p-3 gap-2">
                    <Icon name="filter" size={16} color="!color-white-500" />
                    <div className="font-bold">Filter</div>
                  </div>
                  <div className="flex col-span-3 justify-center !ml-8 items-center p-3 gap-2">
                    <Icon name="document" size={16} color="!color-white-500" />
                    <div className="font-bold">Value</div>
                  </div>
                  <div className="flex col-span-6 justify-center !ml-0 items-center p-3 gap-2">
                    <Icon name="score" size={16} color="!color-white-500" />
                    <div className="font-bold">Score</div>
                  </div>
                </header>
                {fields.map((item, index) => {
                  const fieldName = form.watch(
                    `rows.${index}.name`
                  ) as unknown as {
                    label?: keyof typeof OPTIONS_FILTER_SCORING;
                  };
                  const localeOptions = !fieldName?.label
                    ? null
                    : OPTIONS_FILTER_SCORING[fieldName?.label];
                  return (
                    <div
                      key={item.id}
                      className="flex flex-col md:flex-row gap-4 justify-between w-full col-span-12 items-center"
                    >
                      <div className="w-full">
                        <Controller
                          name={`rows.${index}.name`}
                          render={({ field }) => {
                            return (
                              <InputSelect
                                options={OPTIONS_LEADSCORE_FILTER as []}
                                state={[field.value] as any}
                                variant="light"
                                isSearchable={false}
                                setState={(value: { value: string }) => {
                                  field.onChange(value);
                                  form.resetField(`rows.${index}.value`);
                                  if (value === null) {
                                    form.setValue(`rows.${index}.weight`, 0);
                                  }
                                }}
                                placeholder="Select..."
                                isMulti={false}
                              />
                            );
                          }}
                        />
                      </div>
                      <div className="w-full z-50">
                        <Controller
                          name={`rows.${index}.value`}
                          defaultValue={null}
                          render={({ field }) => {
                            const filterValue = form.watch(
                              `rows.${index}.name`
                            ) as unknown as { value: string };
                            return localeOptions === null ? (
                              <InputField
                                size="small"
                                placeholder="Type a value..."
                                value={field.value}
                                onChange={field.onChange}
                              />
                            ) : (
                              <InputSelect
                                options={(localeOptions as []) || []}
                                state={field.value}
                                setState={(value: string) => {
                                  field.onChange(value);
                                }}
                                placeholder="Select..."
                                isMulti
                                variant="light"
                                isCopyPaste={
                                  filterValue.value === "Target Account"
                                }
                              />
                            );
                          }}
                        />
                      </div>
                      <InputRange
                        name={`rows.${index}.weight`}
                        disabled={!form.watch(`rows.${index}.name`)}
                        containerClass="!min-w-fit w-full !gap-0 !h-[40px] !max-h-[40px] rounded-lg bg-paper-400 h-full !justify-start items-start"
                        elementsClass="!w-7 !h-full !rounded-0 "
                      />
                      <div className="flex justify-end row-span-2">
                        <Button
                          action="button"
                          size="xs"
                          iconName="trash"
                          iconSize={16}
                          className={`!border !border-solid !font-bold !text-[14px] !text-gray-100  !bg-paper-400 !border-gray-700`}
                          onClick={() => remove(index)}
                        ></Button>
                      </div>
                    </div>
                  );
                })}
              </section>
            </>
          ) : (
            <div className="w-full col-span-12 justify-center flex items-center">
              <Empty message="No ICP added yet" title="No ICP" />
            </div>
          )}
        </>
      ) : (
        <section className="col-span-12 grid-rows-1 grid grid-cols-12 w-full gap-4 mt-4">
          <div className="col-span-12 w-full">
            <Controller
              name="state"
              defaultValue={null}
              render={({ field }) => {
                return (
                  <InputSelect
                    label="Company Location"
                    options={(OPTIONS_LOCATION_COUNTRY as []) || []}
                    state={field.value}
                    setState={(value: any) => {
                      let hasSelectNationWide = value[value.length - 1];
                      if (hasSelectNationWide?.value === "nation_wide") {
                        field.onChange({ label: "Nation Wide", value: value });
                        return;
                      } else {
                        const removeNationWide = value?.filter(
                          (item: Options) => item.label !== "Nation Wide"
                        );
                        field.onChange(removeNationWide);
                      }
                    }}
                    placeholder="Select Company Location..."
                    isMulti
                    variant="light"
                  />
                );
              }}
            />
          </div>
        </section>
      )}
      <div className="w-full flex justify-end items-end gap-4 mt-4">
        {businessType === "B2B" && (
          <Button
            size="sm"
            action="button"
            buttonContainerClassName="flex-row-reverse gap-4"
            onClick={() => {
              append({ name: null, weight: 0 } as any);
            }}
            iconName="filter"
            iconSize={16}
            type="outline"
          >
            Add Filter
          </Button>
        )}
        <Button
          size="sm"
          action="submit"
          iconName="arrow-right"
          buttonContainerClassName="flex-row-reverse gap-4"
          disabled={!form.formState.isValid}
          onClick={() => form.setValue("activeStep", 3)}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
